// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { initializeFirestore } from 'firebase/firestore';
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAsuDcqHdWYOdVkzpl18aqP2HWOWS5t7cc",
  authDomain: "venue-board-test.firebaseapp.com",
  projectId: "venue-board-test",
  storageBucket: "venue-board-test.firebasestorage.app",
  messagingSenderId: "996381334441",
  appId: "1:996381334441:web:10b27fabc1f3293d3702b8",
  measurementId: "G-7R1JCWK7D6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
// Safari/WebKit mata el transporte streaming de Firestore ("due to access
// control checks" en Listen/channel) y el SDK tarda ~30s en caer a long
// polling; en WebKit lo forzamos desde el arranque.
const isWebKit =
  typeof navigator !== "undefined" &&
  (/apple/i.test(navigator.vendor || "") ||
    /iP(ad|hone|od)/.test(navigator.userAgent || ""));

export const db = initializeFirestore(
  app,
  isWebKit ? { experimentalForceLongPolling: true } : {}
);
export const storage = getStorage(app);
export const analytics = getAnalytics(app);